import React from 'react'
import { Desc, Head2 } from '../../../../../Components/Typography/Text.styles'
import { colors } from '../../../../../Components/consts'

export const Freestyle: React.FC = () => {
  return (
    <>
      <Head2 textColor={colors.gray.gray20} vertMargins={2}>
        {'Rules'}
      </Head2>
      <ul>
        <li>
          <Desc
            textColor={colors.gray.gray20}
          >{`Each athlete will have 30s to score an air gait or crease dive style goal in the most creative way possible`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`Round 1: Five athletes`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`Round 2: Two finalists`}</Desc>
        </li>
      </ul>
    </>
  )
}
